import React from 'react'
import { string, func } from 'prop-types'
import PlayStore from '../components/graphic/PlayStoreSVG'
import AppleStore from '../components/graphic/AppleStoreSVG'
import { AnalyticsOnClick } from '@pcln/react-analytics'

import { Link } from 'pcln-design-system'

const generateStore = type => (type === 'iOS' ? <AppleStore /> : <PlayStore />)

const AppDownloadButton = ({ linkUrl, storeType, clickAction }) => (
  <AnalyticsOnClick action='Click' label='DownloadApp'>
    <Link
      href={linkUrl}
      target='_blank'
      style={{
        margin: '8px 8px 0 0'
      }}
      onClick={clickAction}
    >
      {generateStore(storeType)}
    </Link>
  </AnalyticsOnClick>
)

AppDownloadButton.displayName = 'AppDownloadButton'

AppDownloadButton.propTypes = {
  linkUrl: string,
  storeType: string,
  clickAction: func
}

export default AppDownloadButton
